module.exports = __webpack_public_path__ + "static/4-2d29aeeebdd62e5d8a3cb0a523ae8541.png";